import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { site } from '@panel/commons/helpers';
import contactIcon from '../../../assets/icons/contactIcon.svg';
import contactIconUB from '../../../assets/icons/contactIcon_UB.svg';

const siteId = site.id;

const Container = styled.div`
  width: 100%;
  height: ${({ device }) => (device === 'mobile' ? '494px' : '320px')};
  padding: ${({ device }) => (device === 'mobile' ? '81px 0px' : '118px 0px')};
  font-family: 'Hind';
  font-style: normal;
  display: flex;
  flex-direction: ${({ device }) => (device === 'mobile' ? 'column' : 'row')};
  justify-content: center;
  align-items: center;
  gap: ${({ device }) => (device === 'mobile' ? '24px' : '121px')};
  background-color: ${select('neutralGray')};
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        flex-direction: column;
        gap: 32px;
      `}
  }
`;

const BoxContainer = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device === 'mobile' ? 'column' : 'row')};
  align-items: center;
  gap: 16px;
`;

const Icon = styled.div`
  width: ${({ device }) => (device === 'mobile' ? '50px' : '53px')};
  height: ${({ device }) => (device === 'mobile' ? '50px' : '53px')};
  background-image: url(${siteId === 'UBPE' ? contactIconUB : contactIcon});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin-bottom: ${({ device }) => (device === 'mobile' ? '0px' : '10px')};
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        margin-bottom: 0px;
      `}
  }
`;

const BoxContainerSecond = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device === 'mobile' ? 'column' : 'row')};
  gap: ${({ device }) => (device === 'mobile' ? '24px' : '59px')};
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        align-items: center;
        justify-content: center;
        gap: 0px;
      `}
  }
`;

const TitleHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  text-align: ${({ device }) => (device === 'mobile' ? 'center' : 'auto')};
  ${({ highSize }) =>
    highSize &&
    css`
      font-weight: 700;
      font-size: 24px;
      line-height: 130%;
    `}
`;

const TextContainer = styled.p`
  width: ${({ device }) => (device === 'mobile' ? '240px' : '200px')};
  margin-top: ${({ device, highSize }) => (device === 'mobile' && highSize ? '16px' : '5px')};
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  white-space: break-spaces;
  text-align: ${({ device }) => (device === 'mobile' ? 'center' : 'start')};
  color: ${select('grayDarkLight')};
  @media (max-width: 820px) {
    ${({ device, highSize }) =>
      device === 'tablet' &&
      highSize &&
      css`
        width: 340px;
      `}
  }
`;

export { Container, BoxContainer, Icon, BoxContainerSecond, TitleHeader, TextContainer };
